"use client";
import { Suspense } from "react";
import dynamic from "next/dynamic";

import { useStore, observer } from "../../../service/mobx";

const LoggedIn = dynamic(() => import("./LoggedIn"));
const LoggedOut = dynamic(() => import("./LoggedOut"));

function Client({ count, models, tasksWithCounts, trending }) {
  const { user } = useStore();
  const Component = user.isAnonymous ? LoggedOut : LoggedIn;

  return user.loaded ? (
    <Suspense>
      <Component
        count={count}
        models={models}
        trending={trending}
        tasksWithCounts={tasksWithCounts}
      />
    </Suspense>
  ) : null;
}

export default observer(Client);
